import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer'
import { SearchHeader } from '@ifca-root/react-component/src/components/Header/SearchHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  Checkbox,
  FormControlLabel,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  GetAssignedUserByDebtorTypeDocument,
  GetDebtorTypeDocument,
  useAssignDebtorTypeMutation,
  useGetCompanyQuery,
  useGetDebtorTypeQuery,
  useUnassignDebtorTypeMutation,
} from 'generated/graphql'
import { useFuseSearch } from 'helpers/Hooks/useSearch'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory, useParams } from 'react-router-dom'

interface AvailableUserProps {
  userID: String
  debtorTypeID: String
  companyID: String
}

export const DebtorTypeAvailableUserForm = (props: any) => {
  let history = useHistory()
  const CompanyID = localStorage.getItem('latestCompany')
  const { DebtorTypeID }: any = useParams()
  const [entity, setEntity] = useState<Set<any>>()
  const { filteredList, handleSearch, setOriginalListing } = useFuseSearch()
  const { pageMode, user }: any = props
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )
  const { handleSubmit } = useForm<AvailableUserProps>({
    defaultValues: {},
    mode: 'all',
  })

  const {
    loading: companyLoading,
    error: companyError,
    data: { getCompany: getCompany } = { getCompany: [] },
  } = useGetCompanyQuery({
    fetchPolicy: 'network-only',
  })

  const {
    loading: scheduledPurchasesLoading,
    error: scheduledPurchasesError,
    data: { getDebtorType } = { getDebtorType: {} as any },
  } = useGetDebtorTypeQuery({
    fetchPolicy: 'network-only',
    variables: { DebtorTypeID: DebtorTypeID },
  })

  const [
    assignDebtorTypes,
    {
      loading: assignDebtorTypeLoading,
      error: assignDebtorTypeError,
      data: assignedDebtorTypeData,
    },
  ] = useAssignDebtorTypeMutation({
    onError: error => {
      console.log('ERROR', error)
    },
    onCompleted: data => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.updateRecord())
    },
  })
  const [
    unassignDebtorType,
    {
      loading: unassignDebtorTypeLoading,
      error: unassignDebtorTypeError,
      data: unassignedDebtorTypeData,
    },
  ] = useUnassignDebtorTypeMutation({
    onError: error => {
      console.log('ERROR', error)
    },
    onCompleted: data => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.updateRecord())
      setEntity(new Set(undefined))
    },
  })

  const handleCreateUpdate =
    pageMode === 'available' ? assignDebtorTypes : unassignDebtorType

  useEffect(() => {
    setOriginalListing(user || [])
    setEntity(new Set())
  }, [user]) // Remove setOriginalListing from dependencies
  /* -------------------------------------------- */
  /*                   FUNCTION                   */
  /* -------------------------------------------- */
  // handle checkbox for all
  const handleSelectAll = (e: any) => {
    let temp = entity || new Set()
    if (!e?.target?.checked) {
      temp.clear()
    } else {
      filteredList.forEach(v => {
        temp.add(v)
      })
    }
    setEntity(new Set(temp))
  }

  // handle checkbox for specific user
  const handleCheckBoxChange = (e: any, index: number) => {
    let entityTemp = entity || new Set()
    if (!e.target.checked) {
      filteredList.find(v => {
        if (v.userID === e.target.value) {
          entityTemp.delete(v)
        }
      })
    } else {
      filteredList.find(v => {
        if (v.userID === e.target.value) {
          entityTemp.add(v)
        }
      })
    }
    setEntity(new Set(entityTemp))
  }

  let listCheckedEntity = Array.from(entity || [])

  const userArray = listCheckedEntity?.map(v => {
    return v.userID
  })

  const assignOption = {
    name: 'Assign',
    onClick: () => {
      handleSubmit(onSubmit)()
    },
    color: 'primary',
  }
  const unassignOption = {
    name: 'Unassign',
    onClick: () => {
      handleSubmit(onSubmit)()
    },
    color: 'primary',
  }

  const submitOption: any[] =
    pageMode === 'available' ? [assignOption] : [unassignOption]
  const onSubmit = data => {
    handleCreateUpdate({
      variables: {
        input: {
          DebtorTypeID: DebtorTypeID,
          userID: userArray,
        },
      },
      refetchQueries: [
        {
          query: GetDebtorTypeDocument,
          variables: { DebtorTypeID: DebtorTypeID },
        },
        {
          query: GetAssignedUserByDebtorTypeDocument,
          variables: { DebtorTypeID: DebtorTypeID },
        },
      ],
      awaitRefetchQueries: true,
    })
  }
  console.log('filteredList: ', filteredList)

  return (
    <>
      {companyLoading && <Loading />}
      {scheduledPurchasesLoading && <Loading />}
      {assignDebtorTypeLoading && <Loading />}
      {unassignDebtorTypeLoading && <Loading />}
      <div className="tab-subheader">
        <SearchHeader
          title="Search here.."
          value={`${filteredList?.length || 0}`}
          search
          onChangeAction={e => {
            handleSearch(e?.target?.value, ['Name'])
          }}
          onCloseAction={() => handleSearch('', [])}
        />
      </div>

      <ContentWrapper float>
        {filteredList?.length === 0 ? (
          <EmptyList
            title={`No ${
              pageMode === 'available' ? 'available' : 'assigned'
            } users`}
          />
        ) : (
          <>
            <ListItem style={{ padding: '0px 16px' }}>
              <FormControlLabel
                className="select-all-font"
                control={
                  <Checkbox
                    color="primary"
                    onChange={e => {
                      handleSelectAll(e)
                    }}
                    checked={entity?.size === filteredList?.length}
                  />
                }
                label={<span className="xsTitle flex-space">Select All</span>}
                style={{ paddingLeft: '7px' }}
              />
            </ListItem>

            <CardContents>
              <List disablePadding>
                {filteredList
                  ?.sort((a, b) => {
                    return a.Name.localeCompare(b.Name)
                  })
                  .map((v, index) => {
                    return (
                      <ListItem disableGutters style={{ padding: '0px' }}>
                        <Checkbox
                          color="primary"
                          value={v.userID}
                          onChange={e => {
                            handleCheckBoxChange(e, index)
                          }}
                          checked={
                            !!listCheckedEntity.find(
                              (el: any) => el.userID === v.userID
                            ) || entity?.size === filteredList?.length
                          }
                        />
                        <ListItemText
                          primary={
                            <div className="xsTitle text-noflow">{v.Name}</div>
                          }
                          secondary={
                            <>
                              {v.children?.length > 0 && (
                                <span className="desc text-no-flow">
                                  {v?.selected ? v?.selected : 0}
                                  <span style={{ margin: '0px 4px' }}>/</span>
                                  {v.children?.length} Accessible
                                </span>
                              )}
                            </>
                          }
                        />
                      </ListItem>
                    )
                  })}
              </List>
            </CardContents>
          </>
        )}
      </ContentWrapper>
      <Footer options={[...submitOption]} />
    </>
  )
}
